{
  "sectionId": "authorization",
  "header": "",
  "available_actions": null,
  "attributes": [
    {
      "attribute_ID": "orgId",
      "fieldName": "orgId",
      "label": "MCO",
      "type": "input",
      "mandatory": "Y",
      "validator": null,
      "tooltip": "Please select an MCO",
      "isAvailable": "Y",
      "placeholder": ""
    },
    {
      "attribute_ID": "servicecodeDetailId",
      "fieldName": "servicecodeDetailId",
      "label": "Service Code",
      "type": "input",
      "mandatory": "Y",
      "validator": null,
      "tooltip": "Please select a Service Code",
      "isAvailable": "Y",
      "placeholder": "Service Code"
    },
    {
      "attribute_ID": "providerId",
      "fieldName": "providerId",
      "label": "Personal Assistant",
      "type": "input",
      "mandatory": "Y",
      "validator": null,
      "tooltip": "Please select a Personal Assistant",
      "isAvailable": "Y",
      "placeholder": "PA"
    },
    {
      "attribute_ID": "startDate",
      "fieldName": "startDate",
      "label": "Start Date",
      "type": "input",
      "mandatory": "Y",
      "validator": null,
      "tooltip": "Please select a Start Date",
      "isAvailable": "Y",
      "placeholder": "Start Date"
    },
    {
      "attribute_ID": "endDate",
      "fieldName": "endDate",
      "label": "End Date",
      "type": "input",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Please select an End Date",
      "isAvailable": "Y",
      "placeholder": "End Date"
    },
    {
      "attribute_ID": "weeklyLimitHrs",
      "fieldName": "weeklyLimitHrs",
      "label": "Weekly Limit",
      "type": "input",
      "mandatory": "Y",
      "validator": null,
      "isAvailable": "Y",
      "tooltip": "Please add Hours",
      "placeholder": ""
    },
    {
      "attribute_ID": "weeklyLimitMins",
      "fieldName": "weeklyLimitMins",
      "label": "weeklyLimitMins",
      "type": "input",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Please add Minutes",
      "isAvailable": "Y"
    },
    {
      "attribute_ID": "comments",
      "fieldName": "comments",
      "label": "Comments",
      "type": "select",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Please add a Comment",
      "isAvailable": "Y"
    },
    {
      "attribute_ID": "units",
      "fieldName": "units",
      "label": "Units",
      "type": "input",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Units",
      "isAvailable": "Y"
    }
  ],
  "validations": [
    {
      "whatToCheck": "atLeastXEntered",
      "clientOrServer": "C",
      "attributes": [
        {
          "validatorid": 1,
          "attribute_ID": ["startDate"],
          "functionParams": {
            "ErrMsg": "Please enter a Start Date."
          }
        },
        {
          "validatorid": 2,
          "attribute_ID": ["orgId"],
          "functionParams": {
            "ErrMsg": "Please select an MCO."
          }
        },
        {
          "validatorid": 3,
          "attribute_ID": ["servicecodeDetailId"],
          "functionParams": {
            "ErrMsg": "Please select a Service Code."
          }
        },
        {
          "validatorid": 4,
          "attribute_ID": ["providerId"],
          "functionParams": {
            "ErrMsg": "Please select a Personal Assistant."
          }
        }
      ]
    },
    {
      "whatToCheck": "checkFieldValue",
      "clientOrServer": "C",
      "attributes": []
    },
    {
      "whatToCheck": "conditionalCheck",
      "clientOrServer": "C",
      "attributes": []
    },
    {
      "whatToCheck": "customValidator",
      "clientOrServer": "C",
      "attributes": []
    }
  ],
  "actions": [
    {
      "Name": "Previous",
      "Validate": null
    },
    {
      "Name": "Next",
      "Validate": [
        {
          "checkType": "atLeastXEntered",
          "validatorid": [1, 2, 3, 4]
        },
        {
          "checkType": "conditionalCheck",
          "validatorid": []
        },
        {
          "checkType": "checkFieldValue",
          "validatorid": []
        },
        {
          "checkType": "customValidator",
          "validatorid": []
        }
      ]
    }
  ]
}
